"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const processAPIRequest_1 = __importDefault(require("../../shared/processAPIRequest"));
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const getEnsuredAppIdFromProcessor_1 = __importDefault(require("../getEnsuredAppIdFromProcessor"));
const apiModuleBuilder = ({ axios, getApiBaseInputs, setApiBaseInputs, }) => async ({ entryVars, moduleDefinition, functionId, callbacks, executeProcesses, processor, }) => {
    var _a, _b, _c;
    try {
        if (!moduleDefinition) {
            throw new Error('No moduleDefinition on an apiModule call');
        }
        // retrieves api information
        const apiInformation = processor.root.getAPIInformationById(moduleDefinition.apiId);
        if (!apiInformation) {
            throw new Error(`The api with id ${moduleDefinition.apiId} was not found`);
        }
        // Compatibility with existing apis modules
        let actualModule = moduleDefinition;
        // Extracts the latest version form the api definition
        if (moduleDefinition.moduleId) {
            const apiModuleCategories = ((_a = apiInformation === null || apiInformation === void 0 ? void 0 : apiInformation.definition) === null || _a === void 0 ? void 0 : _a.modulesCategories) || {};
            const moduleListEntry = Object.entries(apiModuleCategories)
                .find(([, moduleCategory]) => (moduleCategory
                && moduleCategory.modules
                && moduleDefinition.moduleId
                && moduleCategory.modules[moduleDefinition.moduleId]));
            const moduleFound = (_c = (_b = moduleListEntry === null || moduleListEntry === void 0 ? void 0 : moduleListEntry[1]) === null || _b === void 0 ? void 0 : _b.modules) === null || _c === void 0 ? void 0 : _c[moduleDefinition.moduleId];
            if (moduleFound) {
                actualModule = moduleFound;
            }
        }
        const appId = (0, getEnsuredAppIdFromProcessor_1.default)('apiModuleBuilder', processor);
        const customBaseInputs = await getApiBaseInputs(appId);
        const baseInputValues = Object.assign(Object.assign({}, apiInformation.baseInputValues || {}), customBaseInputs);
        if ((0, valueIsNullOrUndef_1.default)(actualModule.requestType)) {
            executeProcesses(functionId, callbacks.error, `Request type should be defined on module ${actualModule.name}`);
            return;
        }
        const apiResponse = await (0, processAPIRequest_1.default)({
            axios,
            baseDefinition: apiInformation.definition.baseDefinition || {},
            baseInputValues,
            baseInputFields: apiInformation.definition.configInputs,
            endPoint: actualModule.endPoint,
            inputFields: actualModule.inputFields,
            outputFields: actualModule.outputFields,
            inputValues: entryVars,
            requestType: actualModule.requestType,
            requestDefinition: actualModule.requestDefinition,
        });
        const { response, rawResponse } = apiResponse;
        if (rawResponse && actualModule.baseInputsUpdater) {
            const formatBaseInputsUpdater = actualModule.baseInputsUpdater;
            let finalResponse = Object.assign({}, customBaseInputs);
            Object.entries(formatBaseInputsUpdater).forEach(([key, value]) => {
                const responseRecord = rawResponse;
                const finalValue = responseRecord[value.outputValue] || undefined;
                if (finalValue) {
                    finalResponse = Object.assign(Object.assign({}, finalResponse), { [key]: finalValue });
                }
            });
            await setApiBaseInputs(appId, finalResponse);
        }
        let completeResponse = response;
        if (Object.keys(response || {}).length < 1) {
            completeResponse = rawResponse;
        }
        executeProcesses(functionId, callbacks.success, completeResponse);
    }
    catch (error) {
        executeProcesses(functionId, callbacks.error, (0, getValueByPathFromUnknown_1.default)(error, ['response', 'data']));
    }
};
exports.default = apiModuleBuilder;
